import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=8b2cf6a6&"
import script from "./Inquiry.vue?vue&type=script&lang=ts&"
export * from "./Inquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports